import React, { Component } from "react";
import PropTypes from "prop-types";
import { Mutation } from "react-apollo";

import { Fieldset, Button, Field, Label, Control, Input, Textarea } from "rbx";
import Section from "../Section";

import { CREATE_LOCATION_TANK_MUTATION } from "../../graphql/Locations/LocationTanks.graphql";

import { ourToast as toast } from "../../utils";

class AddLocationTankForm extends Component {
  state = {
    Description: "",
    Quantity: 0,
    Size: 0
  };

  onChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value });
  };

  render() {
    const { onComplete, id } = this.props;
    const { Description, Quantity, Size } = this.state;
    return (
      <Mutation
        mutation={CREATE_LOCATION_TANK_MUTATION}
        refetchQueries={["ALL_LOCATION_TANKS_QUERY"]}
        variables={{
          data: {
            LocationRecIdRef: id,
            Description,
            Quantity: parseInt(Quantity),
            Size: parseInt(Size)
          }
        }}
      >
        {(createLocationTank, { loading, error }) => (
          <Section title="Add Location Tank">
            <form
              id="add-location-tank"
              onSubmit={async e => {
                e.preventDefault();
                try {
                  await createLocationTank();
                  onComplete();
                  toast.success("Added Location Tank successfully.");
                } catch (err) {
                  toast.error("Error creating Location Tank.");
                }
              }}
            >
              <Fieldset disabled={loading}>
                <Field kind="group">
                  <Control expanded>
                    <Label>Quantity</Label>
                    <Input
                      required
                      autocomplete="new"
                      min="0"
                      name="Quantity"
                      type="number"
                      value={Quantity}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <Label>Size</Label>
                    <Input
                      required
                      autocomplete="new"
                      min="0"
                      name="Size"
                      type="number"
                      value={Size}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field>
                  <Control>
                    <Label>Description</Label>
                    <Textarea
                      name="Description"
                      rows="3"
                      value={Description}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <hr />
                <Field kind="group">
                  <Control>
                    <Button color="primary" type="submit">
                      Submit
                    </Button>
                  </Control>
                  <Control>
                    <Button type="button" onClick={onComplete}>
                      Cancel
                    </Button>
                  </Control>
                </Field>
              </Fieldset>
            </form>
          </Section>
        )}
      </Mutation>
    );
  }
}

AddLocationTankForm.propTypes = {
  onComplete: PropTypes.func,
  id: PropTypes.number
};
export default AddLocationTankForm;
